<template lang="pug">
  .servers
    h3.cod4 CoD4 Servers #[span.toggle-server-list(@click="toggleCoD4", :class="{ active: visibleCoD4 }") #[chevron-down-icon]]
    table(cellspacing="0", cellpadding="0", v-if="visibleCoD4")
      tr(v-for="server of serversCoD4")
        td.server-info
          span.name
            router-link(:to="{ path: server.id }", title="Server Info & Statistics") {{ server.displayName }}
          span.ip(title="Server IP (Click to copy to clipboard)", @click="toClipboard($event)") {{ server.ip }}
        td.dead(v-if="server.dead")
          span Offline
        td.map-info(v-if="!server.dead")
          span(title="Current map").map {{ server.map }}
        td.player-info(v-if="!server.dead")
          span(@click="toggle(server.ip)", title="Online players").player-count
            .fill(:style="{ width: ((server.players.length + server.bots.length) / server.maxplayers * 100) + '%', background: (server.players.length + server.bots.length) / server.maxplayers <= .33 ? '#2ecc71' : ((server.players.length + server.bots.length) / server.maxplayers < .67 ? '#488fc1' : ((server.players.length + server.bots.length) / server.maxplayers < 1 ? '#f1c40f' : '#c13d3d')) }")
            span.abs {{ server.players.length }}#[span(v-if="server.bots.length > 0", title="Bots") &nbsp;({{ server.bots.length }})] / {{ server.maxplayers }}
        td.stats
          router-link(:to="{ path: server.id }", title="Server Info & Statistics") #[chart-areaspline-icon]
          span.toggle-player-list(@click="toggle(server.ip)", :class="{ active: toggled.includes(server.ip) }")
            chevron-down-icon
        td.player-list(v-if="toggled.includes(server.ip)")
          h4 Online players
          ul
            li(v-for="player of server.players.concat(server.bots)")
              p {{ player.name }}
            li(v-if="server.players.concat(server.bots).length <= 0")
              p Server empty

    h3.csgo CS:GO Servers #[span.toggle-server-list(@click="toggleCSGO", :class="{ active: visibleCSGO }") #[chevron-down-icon]]
    table(cellspacing="0", cellpadding="0", v-if="visibleCSGO")
      tr(v-for="server of serversCSGO")
        td.server-info
          span.name
            router-link(:to="{ path: server.id }", title="Server Info & Statistics") {{ server.displayName }}
          a.ip(title="Server IP (Click to join)", :href="`steam://connect/${server.ip}`") {{ server.ip }}
        td.dead(v-if="server.dead")
          span Offline
        td.map-info(v-if="!server.dead")
          span(title="Current map").map {{ server.map }}
        td.player-info(v-if="!server.dead")
          span(@click="toggle(server.ip)", title="Online players").player-count
            .fill(:style="{ width: ((server.players.length + server.bots.length) / server.maxplayers * 100) + '%', background: (server.players.length + server.bots.length) / server.maxplayers <= .33 ? '#2ecc71' : ((server.players.length + server.bots.length) / server.maxplayers < .67 ? '#488fc1' : ((server.players.length + server.bots.length) / server.maxplayers < 1 ? '#f1c40f' : '#c13d3d')) }")
            span.abs {{ server.players.length }}#[span(v-if="server.bots.length > 0", title="Bots") &nbsp;({{ server.bots.length }})] / {{ server.maxplayers }}
        td.stats
          router-link(:to="{ path: server.id }", title="Server Info & Statistics") #[chart-areaspline-icon]
          span.toggle-player-list(@click="toggle(server.ip)", :class="{ active: toggled.includes(server.ip) }")
            chevron-down-icon
        td.player-list(v-if="toggled.includes(server.ip)")
          h4 Online players
          ul
            li(v-for="player of server.players.concat(server.bots)")
              p {{ player.name }}
            li(v-if="server.players.concat(server.bots).length <= 0")
              p Server empty

    p.last-updated Last updated {{ updated }} second(s) ago
</template>

<script>
import ServerQueryService from '@/services/ServerQuery';

import ChartAreasplineIcon from 'vue-material-design-icons/ChartAreaspline.vue';
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';

export default {
  name: 'servers',
  components: {
    ChartAreasplineIcon,
    ChevronDownIcon,
  },
  data() {
    return {
      serversCoD4: [],
      serversCSGO: [],
      visibleCoD4: true,
      visibleCSGO: true,
      updated: 0,
      toggled: [],
      timer: null,
      timerUpdated: null,
    };
  },
  methods: {
    toggleCoD4() {
      this.visibleCoD4 = !this.visibleCoD4;
      if (this.visibleCoD4) {
        this.update();
      }
    },
    toggleCSGO() {
      this.visibleCSGO = !this.visibleCSGO;
      if (this.visibleCSGO) {
        this.update();
      }
    },
    async update() {
      let response = await ServerQueryService.updateCoD4();
      if (response.error) {
        console.log(response.error);
      } else {
        this.serversCoD4 = response.data.servers;
      }
      response = await ServerQueryService.updateCSGO();
      if (response.error) {
        console.log(response.error);
      } else {
        this.serversCSGO = response.data.servers;
      }
      this.updated = 0;
    },
    toggle(ip) {
      if (this.toggled.includes(ip)) {
        this.toggled.splice(this.toggled.indexOf(ip), 1);
      } else {
        this.toggled.push(ip);
      }
    },
    toClipboard(event) {
      const copyField = document.createElement('textarea');
      document.querySelector('body').appendChild(copyField);
      copyField.value = event.target.textContent;
      copyField.select();
      document.execCommand('copy');
      copyField.remove();
    },
  },
  created() {
    this.update();
    this.timer = setInterval(this.update, 30000);
    this.timerUpdated = setInterval(() => {
      this.updated += 1;
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.timerUpdated);
  },
};
</script>

<style lang="scss">
@import '@/style/definitions';

.servers {
  h3 {
    position: relative;

    &.csgo {
      margin-top: 32px;
    }

    span.toggle-server-list {
      svg {
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
        fill: $color-fg;
      }

      &.active svg {
        transform: translateY(-50%) rotate(180deg);
      }
    }
  }

  table {
    tr {
      td {
        display: inline-block;

        span {
          &.name {
            display: inline-block;
            width: 100%;
            white-space: nowrap;
            font-size: 15px;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          &.ip {
            cursor: pointer;
            font-size: 12px;

            &:hover, &:focus {
              color: $color-accent;
            }
          }
        }

        a.ip {
          font-size: 12px;
        }

        &.dead {
          width: calc(65% - 128px);
          font-size: 15;
          color: #c13d3d;
          text-align: right;
        }

        &.server-info {
          width: 35%;

          @media screen and (max-width: 979px) {
            width: 50%;
          }
        }

        &.map-info {
          width: calc(40% - 128px);

          @media screen and (max-width: 979px) {
            width: 50%;
            text-align: right;
          }
        }

        &.player-info {
          width: 25%;

          .player-count {
            cursor: pointer;
            display: block;
            position: relative;
            width: 100%;
            background: $gray;
            border-radius: 4px;
            height: 32px;
            font-size: 13px;

            .fill {
              display: block;
              height: 32px;
              border-radius: 4px;
            }

            span.abs {
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
            }
          }

          @media screen and (max-width: 979px) {
            width: calc(100% - 128px);
          }
        }

        &.stats {
          width: 128px;
          height: 64px;

          svg {
            margin: 0 8px;
            width: 32px;
            height: 32px;
            fill: $color-fg;
            background: $gray;
            padding: 6px;
            border-radius: 4px;
          }

          span.toggle-player-list {
            cursor: pointer;

            &.active svg {
              transform: rotate(180deg);
            }
          }

          @media screen and (max-width: 979px) {
            width: 128px;
          }
        }

        &.player-list {
          width: 100%;

          h4 {
            font-weight: 700;
            font-size: 14px;
            padding-bottom: 8px;
          }

          ul {
            list-style: none;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;

            li {
              flex-shrink: 0;
              width: 25%;
              display: inline-block;
              padding: 6px 0;

              @media screen and (max-width: 979px) {
                width: calc(100% / 3);
              }

              @media screen and (max-width: 767px) {
                width: 50%;
              }

              @media screen and (max-width: 480px) {
                width: 100%;
              }
            }
          }
        }
      }
    }
  }

  p.last-updated {
    padding: 16px;
    text-align: center;
  }
}
</style>
